import ThunderstormIcon from "@mui/icons-material/Thunderstorm";
import TsunamiIcon from "@mui/icons-material/Tsunami";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import {
 getAdaptationScenario,
 getGroundwaterCondition,
 getRainfallAmount,
 getSeaLevelRise,
 getStormSurge,
} from "../store/scenarioOne";
import {
 getAdaptationScenario2,
 getGroundwaterCondition2,
 getRainfallAmount2,
 getSeaLevelRise2,
 getStormSurge2,
} from "../store/scenarioTwo";

/*

This file is used to map through the sidebar options

const slr = ["2.0 ft SLR", "3.3 ft SLR"];
const rainfallAmount = ["10-yr", "25-yr", "100-yr", "10-yr + 20%"];
const stormSurge = ["King Tide", "20-yr", "100-yr"];
const groundwaterCondition = ["Variable GW", "Saturated System"];
const adaptations = ["Tier 1", "Tier 2", "None"] // default is "None"

*/

export const stormScenarioConfig = [
 {
  number: "1",
  aB: "a",
  title: "Adaptation Scenario",
  thunk: (option, dispatch) => dispatch(getAdaptationScenario(option)),
  options: [
   ["None", <WbSunnyIcon fontSize="large" sx={{ color: "white" }} />],
   ["Tier 1", <WbSunnyIcon fontSize="large" sx={{ color: "white" }} />],
   ["Tier 2", <WaterDropIcon fontSize="large" sx={{ color: "white" }} />],
  ],
  stateKey: "adaptationScenario",
  switchCase: "setSelectedAdaptation",
  availableKeyName: null, //"availableAdaptation",
  info: (
   <span>
    Adaptation Scenario: This refers to a set of strategies or plans developed
    to adjust to and mitigate the impacts of climate change.
    <a
     href="https://glslcities.org/wp-content/uploads/2015/09/Scenario_planning_for_climate_change_adaptation_-_A_guidance_for_resource_managers_2013.pdf"
     target="blank"
    >
     These scenarios often involve changes in infrastructure, policies, and
     practices to reduce vulnerability and enhance resilience to environmental
     changes.
    </a>
   </span>
  ),
 },
 {
  number: "2",
  aB: "a",
  title: "Sea Level Rise",
  thunk: (option, dispatch) => dispatch(getSeaLevelRise(option)),
  options: [
   ["2.0 ft", null],
   ["3.3 ft", null],
   ["Current", null],
  ],
  stateKey: "SLR",
  switchCase: "setSelectedSLR",
  availableKeyName: "availableSLR",
  info:
   "Sea Level Rise: This refers to the increase in the level of the world's oceans due to factors such as melting ice caps and glaciers, and the thermal expansion of seawater as it warms. ",
 },
 {
  number: "3",
  aB: "a",
  title: "Rainfall Amount",
  thunk: (option, dispatch) => dispatch(getRainfallAmount(option)),
  options: [
   ["5-yr", <ThunderstormIcon fontSize="large" sx={{ color: "white" }} />],
   ["10-yr", <ThunderstormIcon fontSize="large" sx={{ color: "white" }} />],
   ["25-yr", <ThunderstormIcon fontSize="large" sx={{ color: "white" }} />],
   ["50-yr", <ThunderstormIcon fontSize="large" sx={{ color: "white" }} />],
   ["100-yr", <ThunderstormIcon fontSize="large" sx={{ color: "white" }} />],
  ],
  stateKey: "rainfallAmount",
  switchCase: "setSelectedRainfallAmount",
  availableKeyName: "availableRain",
  info:
   "Rainfall Amount: This is the total quantity of rain, in inches, that falls over a specific area within a given period.",
 },
 {
  number: "4",
  aB: "a",
  title: "Storm Surge",
  thunk: (option, dispatch) => dispatch(getStormSurge(option)),
  options: [
   ["No Surge", <TsunamiIcon fontSize="large" sx={{ color: "white" }} />],
   ["20-yr", <TsunamiIcon fontSize="large" sx={{ color: "white" }} />],
   ["100-yr", <TsunamiIcon fontSize="large" sx={{ color: "white" }} />],
  ],
  stateKey: "stormSurge",
  switchCase: "setSelectedStormSurge",
  availableKeyName: "availableStormSurges",
  info: (
   <span>
    Storm Surge: This is the abnormal rise in seawater level during a storm,
    measured as the height of the water above the normal predicted astronomical
    tide.
    <a
     href="https://education.nationalgeographic.org/resource/sea-level-rise/"
     target="blank"
    >
     It is primarily caused by a storm's winds pushing water onshore.
    </a>
   </span>
  ),
 },
 {
  number: "5",
  aB: "a",
  title: "Groundwater Conditions",
  thunk: (option, dispatch) => dispatch(getGroundwaterCondition(option)),
  options: [
   ["Variable GW", <WbSunnyIcon fontSize="large" sx={{ color: "white" }} />],
   [
    "Saturated System",
    <WaterDropIcon fontSize="large" sx={{ color: "white" }} />,
   ],
  ],
  stateKey: "groudwaterConditions",
  switchCase: "setSelectedGroundwaterConditions",
  availableKeyName: "availableGroundwater",
  info:
   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis knostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
 },
];

export const comparedStormScenarioConfig = [
 {
  number: "1",
  aB: "b",
  title: "Adaptation Scenario",
  thunk: (option, dispatch) => dispatch(getAdaptationScenario2(option)),
  options: [
   ["None", <WbSunnyIcon fontSize="large" sx={{ color: "white" }} />],
   ["Tier 1", <WbSunnyIcon fontSize="large" sx={{ color: "white" }} />],
   ["Tier 2", <WaterDropIcon fontSize="large" sx={{ color: "white" }} />],
  ],
  stateKey: "adaptationScenario",
  switchCase: "setSelectedAdaptation",
  availableKeyName: null, //"availableAdaptation",
  info: (
   <span>
    Adaptation Scenario: This refers to a set of strategies or plans developed
    to adjust to and mitigate the impacts of climate change.
    <a
     href="https://glslcities.org/wp-content/uploads/2015/09/Scenario_planning_for_climate_change_adaptation_-_A_guidance_for_resource_managers_2013.pdf"
     target="blank"
    >
     These scenarios often involve changes in infrastructure, policies, and
     practices to reduce vulnerability and enhance resilience to environmental
     changes.
    </a>
   </span>
  ),
 },
 {
  number: "2",
  aB: "b",
  title: "Sea Level Rise",
  thunk: (option, dispatch) => dispatch(getSeaLevelRise2(option)),
  options: [
   ["2.0 ft", null],
   ["3.3 ft", null],
   ["Current", null],
  ],
  stateKey: "SLR",
  switchCase: "setSelectedSLR",
  availableKeyName: "availableSLR",
  info:
   "Sea Level Rise: This refers to the increase in the level of the world's oceans due to factors such as melting ice caps and glaciers, and the thermal expansion of seawater as it warms. ",
 },
 {
  number: "3",
  aB: "b",
  title: "Rainfall Amount",
  thunk: (option, dispatch) => dispatch(getRainfallAmount2(option)),
  options: [
   ["5-yr", <ThunderstormIcon fontSize="large" sx={{ color: "white" }} />],
   ["10-yr", <ThunderstormIcon fontSize="large" sx={{ color: "white" }} />],
   ["25-yr", <ThunderstormIcon fontSize="large" sx={{ color: "white" }} />],
   ["50-yr", <ThunderstormIcon fontSize="large" sx={{ color: "white" }} />],
   ["100-yr", <ThunderstormIcon fontSize="large" sx={{ color: "white" }} />],
  ],
  stateKey: "rainfallAmount",
  switchCase: "setSelectedRainfallAmount",
  availableKeyName: "availableRain",
  info:
   "Rainfall Amount: This is the total quantity of rain, in inches, that falls over a specific area within a given period.",
 },
 {
  number: "4",
  aB: "b",
  title: "Storm Surge",
  thunk: (option, dispatch) => dispatch(getStormSurge2(option)),
  options: [
   ["King Tide", <TsunamiIcon fontSize="large" sx={{ color: "white" }} />],
   ["20-yr", <TsunamiIcon fontSize="large" sx={{ color: "white" }} />],
   ["100-yr", <TsunamiIcon fontSize="large" sx={{ color: "white" }} />],
  ],
  stateKey: "stormSurge",
  switchCase: "setSelectedStormSurge",
  availableKeyName: "availableStormSurges",
  info: (
   <span>
    Storm Surge: This is the abnormal rise in seawater level during a storm,
    measured as the height of the water above the normal predicted astronomical
    tide.
    <a
     href="https://education.nationalgeographic.org/resource/sea-level-rise/"
     target="blank"
    >
     It is primarily caused by a storm's winds pushing water onshore.
    </a>
   </span>
  ),
 },
 {
  number: "5",
  aB: "b",
  title: "Groundwater Conditions",
  thunk: (option, dispatch) => dispatch(getGroundwaterCondition2(option)),
  options: [
   ["Variable GW", <WbSunnyIcon fontSize="large" sx={{ color: "white" }} />],
   [
    "Saturated System",
    <WaterDropIcon fontSize="large" sx={{ color: "white" }} />,
   ],
  ],
  stateKey: "groudwaterConditions",
  switchCase: "setSelectedGroundwaterConditions",
  availableKeyName: "availableGroundwater",
  info:
   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis knostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
 },
];

export const stormScenarioConfigMobile = [
 {
  number: "1",
  aB: "a",
  title: "Adaptation Scenario",
  thunk: (option, dispatch) => dispatch(getAdaptationScenario(option)),
  options: [
   ["None", <WbSunnyIcon fontSize="large" sx={{ color: "white" }} />],
   ["Tier 1", <WbSunnyIcon fontSize="large" sx={{ color: "white" }} />],
   ["Tier 2", <WaterDropIcon fontSize="large" sx={{ color: "white" }} />],
  ],
  stateKey: "adaptationScenario",
  switchCase: "setSelectedAdaptation",
  availableKeyName: null, //"availableAdaptation",
  info: (
   <span>
    Adaptation Scenario: This refers to a set of strategies or plans developed
    to adjust to and mitigate the impacts of climate change.
    <a
     href="https://glslcities.org/wp-content/uploads/2015/09/Scenario_planning_for_climate_change_adaptation_-_A_guidance_for_resource_managers_2013.pdf"
     target="blank"
    >
     These scenarios often involve changes in infrastructure, policies, and
     practices to reduce vulnerability and enhance resilience to environmental
     changes.
    </a>
   </span>
  ),
 },
 {
  number: "2",
  aB: "a",
  title: "Sea Level Rise",
  thunk: (option, dispatch) => dispatch(getSeaLevelRise(option)),
  options: [
   ["2.0 ft", null],
   ["3.3 ft", null],
   ["Current", null],
  ],
  stateKey: "SLR",
  switchCase: "setSelectedSLR",
  availableKeyName: "availableSLR",
  info:
   "Sea Level Rise: This refers to the increase in the level of the world's oceans due to factors such as melting ice caps and glaciers, and the thermal expansion of seawater as it warms. ",
 },
 {
  number: "3",
  aB: "a",
  title: "Rainfall Amount",
  thunk: (option, dispatch) => dispatch(getRainfallAmount(option)),
  options: [
   ["5-yr", <ThunderstormIcon fontSize="large" sx={{ color: "white" }} />],
   ["10-yr", <ThunderstormIcon fontSize="large" sx={{ color: "white" }} />],
   ["25-yr", <ThunderstormIcon fontSize="large" sx={{ color: "white" }} />],
   ["50-yr", <ThunderstormIcon fontSize="large" sx={{ color: "white" }} />],
   ["100-yr", <ThunderstormIcon fontSize="large" sx={{ color: "white" }} />],
  ],
  stateKey: "rainfallAmount",
  switchCase: "setSelectedRainfallAmount",
  availableKeyName: "availableRain",
  info:
   "Rainfall Amount: This is the total quantity of rain, in inches, that falls over a specific area within a given period.",
 },
 {
  number: "4",
  aB: "a",
  title: "Storm Surge",
  thunk: (option, dispatch) => dispatch(getStormSurge(option)),
  options: [
   ["No Surge", <TsunamiIcon fontSize="large" sx={{ color: "white" }} />],
   ["20-yr", <TsunamiIcon fontSize="large" sx={{ color: "white" }} />],
   ["100-yr", <TsunamiIcon fontSize="large" sx={{ color: "white" }} />],
  ],
  stateKey: "stormSurge",
  switchCase: "setSelectedStormSurge",
  availableKeyName: "availableStormSurges",
  info: (
   <span>
    Storm Surge: This is the abnormal rise in seawater level during a storm,
    measured as the height of the water above the normal predicted astronomical
    tide.
    <a
     href="https://education.nationalgeographic.org/resource/sea-level-rise/"
     target="blank"
    >
     It is primarily caused by a storm's winds pushing water onshore.
    </a>
   </span>
  ),
 },
 {
  number: "5",
  aB: "a",
  title: "Groundwater Conditions",
  thunk: (option, dispatch) => dispatch(getGroundwaterCondition(option)),
  options: [
   ["Variable GW", <WbSunnyIcon fontSize="large" sx={{ color: "white" }} />],
   [
    "Saturated System",
    <WaterDropIcon fontSize="large" sx={{ color: "white" }} />,
   ],
  ],
  stateKey: "groudwaterConditions",
  switchCase: "setSelectedGroundwaterConditions",
  availableKeyName: "availableGroundwater",
  info:
   "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis knostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
 },
];
